// utils/fileType.js 或直接在组件中定义

// 文件类型分类
const fileTypes = {
    image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'],
    audio: ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac', 'wma'],
    video: ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'flv', 'm3u8', 'ts', '3gp', 'wmv'],
    document: {
      pdf: ['pdf'],
      word: ['doc', 'docx'],
      excel: ['xls', 'xlsx'],
      powerpoint: ['ppt', 'pptx'],
      text: ['txt', 'md', 'json', 'xml', 'csv'],
      other: ['zip', 'rar', '7z']
    }
  }
  
  /**
   * 获取文件扩展名
   * @param {string} url - 文件URL
   * @returns {string} 小写的文件扩展名
   */
  export const getFileExtension = (url) => {
    if (!url) return ''
    
    // 处理带查询参数的URL
    const urlWithoutParams = url.split('?')[0]
    const fileName = urlWithoutParams.split('/').pop()
    const extension = fileName.split('.').pop()
    
    return extension ? extension.toLowerCase() : ''
  }
  
  /**
   * 获取文件类型分类
   * @param {string} url - 文件URL
   * @returns {object} 包含类型和具体分类的对象
   */
  export const getFileType = (url) => {
    const ext = getFileExtension(url)
    
    if (!ext) return { type: 'unknown', category: 'unknown' }
    
    // 检查图片类型
    if (fileTypes.image.includes(ext)) {
      return { type: 'image', category: ext }
    }
    
    // 检查音频类型
    if (fileTypes.audio.includes(ext)) {
      return { type: 'audio', category: ext }
    }
    
    // 检查视频类型
    if (fileTypes.video.includes(ext)) {
      return { type: 'video', category: ext }
    }
    
    // 检查文档类型
    for (const [docType, exts] of Object.entries(fileTypes.document)) {
      if (exts.includes(ext)) {
        return { type: 'document', category: docType, extension: ext }
      }
    }
    
    return { type: 'unknown', category: 'unknown', extension: ext }
  }
  
  /**
   * 获取文件图标
   * @param {string} url - 文件URL
   * @returns {string} 图标类名或URL
   */
  export const getFileIcon = (url) => {
    const { type, category } = getFileType(url)
    
    const iconMap = {
      image: 'icon-picture',
      audio: 'icon-music',
      video: 'icon-video',
      pdf: 'icon-file-pdf',
      word: 'icon-file-word',
      excel: 'icon-file-excel',
      powerpoint: 'icon-file-ppt',
      text: 'icon-file-text',
      other: 'icon-file-unknown'
    }
    
    return iconMap[category] || iconMap[type] || 'icon-file-unknown'
  }